/* gr-header.js — Header interactivity.
 *   - Announcement rotation
 *   - Mobile menu open/close
 *   - Search modal open/close + focus
 *   - Hide-on-scroll (optional setting)
 *   - Sync cart count with /cart.js on load
 */
(function () {
  'use strict';

  // ── Announcement rotation ─────────────────────────────────
  var ann = document.querySelector('.gr-announce');
  if (ann) {
    var items = ann.querySelectorAll('.gr-announce__item');
    var interval = parseInt(ann.dataset.interval, 10) || 4500;
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        items[i].removeAttribute('data-active');
        i = (i + 1) % items.length;
        items[i].setAttribute('data-active', '');
      }, interval);
    }
  }

  // ── Mobile menu ───────────────────────────────────────────
  var menu = document.getElementById('gr-mobile-menu');
  var ham  = document.querySelector('[data-gr-ham]');
  if (menu && ham) {
    var openMenu = function () {
      menu.setAttribute('aria-hidden', 'false');
      ham.setAttribute('aria-expanded', 'true');
      document.body.classList.add('gr-cart-open');
    };
    var closeMenu = function () {
      menu.setAttribute('aria-hidden', 'true');
      ham.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('gr-cart-open');
    };
    ham.addEventListener('click', openMenu);
    menu.querySelectorAll('[data-gr-ham-close]').forEach(function (n) {
      n.addEventListener('click', closeMenu);
    });
    menu.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') closeMenu();
    });

    // Sub-menu toggles
    menu.querySelectorAll('[data-gr-mobile-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.gr-mobile-menu__item');
        var sub = item.querySelector('.gr-mobile-menu__sub');
        if (!sub) return;
        var isOpen = !sub.hidden;
        sub.hidden = isOpen;
        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  // ── Search modal ──────────────────────────────────────────
  var search = document.getElementById('gr-search-modal');
  if (search) {
    var input = search.querySelector('[data-gr-search-input]');
    var openSearch = function () {
      search.setAttribute('aria-hidden', 'false');
      setTimeout(function () { if (input) input.focus(); }, 240);
    };
    var closeSearch = function () {
      search.setAttribute('aria-hidden', 'true');
    };
    document.querySelectorAll('[data-gr-search-open]').forEach(function (n) {
      n.addEventListener('click', openSearch);
    });
    search.querySelectorAll('[data-gr-search-close]').forEach(function (n) {
      n.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && search.getAttribute('aria-hidden') === 'false') closeSearch();
    });
  }

  // ── Hide-on-scroll ───────────────────────────────────────
  var header = document.querySelector('.gr-header');
  if (header && header.dataset.hideOnScroll === 'true') {
    var lastY = window.scrollY;
    var threshold = 10;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 120 && y - lastY > threshold) header.classList.add('gr-header--hidden');
      else if (lastY - y > threshold || y < 120) header.classList.remove('gr-header--hidden');
      lastY = y;
    }, { passive: true });
  }

  // ── Cart count sync (header mirrors drawer count) ─────────
  var countEls = document.querySelectorAll('[data-gr-cart-count]');
  if (countEls.length) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { countEls.forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }
})();
